<template>
  <div class="m-auto d-flex flex-column align-items-center text-muted" v-if="isLoading"><b-spinner></b-spinner></div>
  <div class="container-fluid p-4" v-else>
    <div class="pb-4 d-flex justify-content-between align-items-center">
      <div class="d-flex flex-column">
        <small class="text-muted mb-1 ">{{$t('global.ansichtBearbeiten')}}: {{$t('amazonumsaetze.titel')}}</small>
        <h1 class="h2">{{$t('amazonumsaetze.laender')}}</h1>
      </div>
      <div class="d-flex">
        <change-order-component :entriesProp="laender" :collection="'amazonLaender'" v-on:orderChanged="updateEntries" :size="'md'"></change-order-component>
        <router-link :to="{ name: 'ErstelleAmazonLand' }" class="btn btn-primary align-self-center"><font-awesome-icon icon="plus" class="mr-2" />{{$t('amazonumsaetze.landErstellen')}}</router-link>
      </div>
    </div>
    <b-card no-body class="shadow-sm">
      <table class="table table-hover mb-0" v-if="laender.length > 0">
        <tbody>
          <tr v-for="element in orderByIndex(laender)" :key="`hersteller-${element.id}`">
            <td class="d-flex justify-content-between align-items-center">
              {{element.data.name}}
              <div>
                <router-link class="btn btn-secondary btn-sm mr-2" :to="{ name: 'BearbeiteAmazonLand', params: { id: element.id } }"><font-awesome-icon icon="edit" /></router-link>
                <button type="button" class="btn btn-danger btn-sm" v-on:click="loeschen(element.id, element.data.name)"><font-awesome-icon icon="trash" /></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="alert alert-warning text-center mb-0" v-else>
        {{$t('global.keineDatenVorhanden')}}
      </div>
    </b-card>
  </div>
</template>

<script>
import ChangeOrderComponent from "../../ChangeOrderComponent"
import _ from 'lodash'

import { firestore } from "../../../firebase"
import { query, collection, orderBy, deleteDoc, doc, getDocs} from "firebase/firestore"

export default {
  name: 'ZeigeAmazonLaender',
  components: { ChangeOrderComponent },
  mounted() {
    this.laden()
  },
  methods: {
    laden: async function() {
      const querySnapshot = await getDocs(query(collection(firestore, "amazonLaender"), orderBy("slug", "asc")))

      querySnapshot.forEach(doc => {
        const element = {
          id: doc.id,
          data: doc.data()
        }
        this.laender.push(element)
      })

      this.isLoading = false

    },
    loeschen: function(id, name) {
      this.$bvModal.msgBoxConfirm(`${this.$t('global.wirklichLoeschen[0]')} "${name}"  ${this.$t('global.wirklichLoeschen[1]')}`, {
        title: '',
        okVariant: 'danger',
        okTitle: this.$t('global.ok'),
        cancelTitle: this.$t('global.abbrechen'),
        hideHeaderClose: false,
        noCloseOnBackdrop: true
      })
      .then(value => {
        if (value === true) {
          deleteDoc(doc(firestore,"amazonLaender", id ))
          .then(() => {
            for(let i = 0; i < this.laender.length; i++){ 
              if (this.laender[i].id === id) {
                this.laender.splice(i, 1)
                i--
              }
            }
          })
          .catch(error => console.error(error)) // eslint-disable-line no-console
        }
      })
      .catch(error => console.error(error)) // eslint-disable-line no-console
    },
    updateEntries: function(data) {
      this.laender = data
    },
    orderByIndex: function(data) {
      return _.orderBy(data, (entry) => entry.data.orderIndex, 'asc')
    }
  },
  data() {
    return {
      isLoading: true,
      laender: []
    }
  }
}
</script>
